import { Dropdown } from "react-bootstrap";
import styles from "./KeyfobListMobile.module.css";
import { Link } from "react-router-dom";
import { MoreVertical, Trash2 } from "react-feather";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        fontSize: 13,
    },
}));

const KeyfobListMobile = ({ item, setDeleteModalOpen, setDeleteCardNumber }) => {
    return <Link to={"/smart-devices/keyfobs/details/" + item?.card_number} className={`${styles.MaintenanceReqCard}`}>
        <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); }}>
            <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                <MoreVertical />
            </Dropdown.Toggle>

            <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                {/* <Dropdown.Item className={`${styles.EditActionsBUListItem}`}>
                        <Edit /> Edit
                        </Dropdown.Item> */}
                <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteModalOpen(true); setDeleteCardNumber(item?.card_number); }}>
                    <Trash2 /> Delete
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
        <div className={`${styles.CardImgSec} Secondary`}>
            <img src="/static/img/door-key-icon.svg" class={`${styles.IMG}`} alt="" />
        </div>
        <div className={`${styles.MainReCardCon}`}>
            <div>
                <p className={`${styles.Title}`}>{item?.card_name}</p>
                <div className={`${styles.MainReCardIdStatus}`}>
                    <p className={styles.MainReID}>{item?.card_number} <span>{item?.card_type}</span></p>
                </div>
                <div className={`${styles.MainReCardIdStatusTwo}`}>
                    {item?.associated_locks?.length > 0 && <BootstrapTooltip title={(<div className={`${styles.TooltipListRow}`}>
                        {item?.associated_locks?.map((i, ind) => {
                            return <div className={`${styles.TooltipList}`}>#{ind + 1}: {i}</div>
                        })}
                    </div>)}>
                        <p className={`${styles.MainReID}`}>
                            {item?.associated_locks[0]}
                            {item?.associated_locks?.length > 1 && <span className={`${styles.MoreBadge}`}>+{item?.associated_locks?.length - 1}</span>}
                        </p>

                    </BootstrapTooltip>}
                </div>
            </div>
        </div>
    </Link>
}

export default KeyfobListMobile;